var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 468 468",
    id: "exclamation-mark",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 234,
    r: 234,
    fill: "#f56c61"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M234 392.862c-87.597 0-158.862-71.265-158.862-158.862S146.403 75.138 234 75.138 392.862 146.403 392.862 234 321.597 392.862 234 392.862z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f56c61",
    d: "M234 294.97c-12.793 0-22.44 10.034-22.44 23.342 0 13.308 9.647 23.342 22.44 23.342 13.003 0 22.44-9.817 22.44-23.342 0-13.743-9.228-23.342-22.44-23.342zm15.634-29.701 6.589-115.396c.729-12.771-9.431-23.528-22.223-23.528s-22.952 10.757-22.223 23.528l6.588 115.396c.473 8.288 7.332 14.767 15.634 14.767s15.161-6.479 15.635-14.767z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation-mark.54fb4740ad507acce45930069e5b0b41.svg";
export { ForwardRef as ReactComponent };